import { ModalProvider } from 'vig-ui-library';
import { MagicLinkAppProvider, MagicLinkView, useMagicLinkAppProvider } from '@/Provider/MagicLinkAppProvider';
import IntroStepView from '@/Views/MagicLink/IntroStepView';
import RequestDetailView from '@/Views/MagicLink/RequestDetailView';
import CameraView from '@/Views/MagicLink/CameraView';
import ExtractedDataView from '@/Views/MagicLink/ExtractedDataView';
import InvalidIdCardView from '@/Views/MagicLink/InvalidIdCardView';
import IdCardUploadedSuccefullyView from '@/Views/MagicLink/IdCardUploadedSuccefullyView';
import UploadIdCardView from '@/Views/MagicLink/UploadIdCardView';
import CancelledLinkView from '@/Views/MagicLink/CancelledLinkView';
import LinkConfirmedView from '@/Views/MagicLink/LinkConfirmedView';

const MagicLinkApp = () => {
    return (
        <ModalProvider>
            <MagicLinkAppProvider>
                <ViewRenderer />
            </MagicLinkAppProvider>
        </ModalProvider>
    );
};

const ViewRenderer = () => {
    const { currentView } = useMagicLinkAppProvider();

    switch (currentView) {
        case MagicLinkView.INTRO:
            return <IntroStepView />;
        case MagicLinkView.REQUEST_DETAIL:
            return <RequestDetailView />;
        case MagicLinkView.CAMERA:
            return <CameraView />;
        case MagicLinkView.EXTRACTED_DATA:
            return <ExtractedDataView />;
        case MagicLinkView.INVALID_ID_CARD:
            return <InvalidIdCardView />;
        case MagicLinkView.ID_CARD_UPLOADED:
            return <IdCardUploadedSuccefullyView />;
        case MagicLinkView.UPLOAD_ID_CARD:
            return <UploadIdCardView />;
        case MagicLinkView.CANCELLED:
            return <CancelledLinkView />;
        case MagicLinkView.LINK_CONFIRMED:
            return <LinkConfirmedView />;
        default:
            return <IntroStepView />;
    }
};

export default MagicLinkApp;
